import { itemsOnPage } from "../assets/const";
import { createNotification } from "../components/Notifications/Notifications";
import { api } from "../App";

import {
    SET_STUDY_PLANS_VD,
    SET_STUDY_PLAN_VD_BY_ID,
    SET_STUDY_PLAN_VD_COURSES_LIST,
    SET_STUDY_PLAN_VD_FILES,
    SET_STUDY_PLAN_VD_LOADING,
    SET_STUDY_PLANS_PAGE,
} from "./types";

export const setPage = (pageNumber) => ({ type: SET_STUDY_PLANS_PAGE, payload: pageNumber })


export const getStudyPlansVD = (params) => async (dispatch, getState) => {
    const { pageNumber } = getState().studyPlans;
    const max_results = itemsOnPage;
    const paginate_from = itemsOnPage * pageNumber;
    let copyParams = {
        ...params,
        limit: max_results,
        offset: paginate_from
    };

    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        const { data } = await api.get(`/out_study_plans`, { params: copyParams });
        dispatch({ type: SET_STUDY_PLANS_VD, payload: data });
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};


export const getStudyPlansVDById = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        const { data } = await api.get(`/out_study_plans/${id}`);
        dispatch({ type: SET_STUDY_PLAN_VD_BY_ID, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
}

export const deleteStudyPlansVD = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        await api.delete(`/out_study_plans/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getStudyPlansVD());
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};

export const editStudyPlanVD = (reqData) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        await api.put(`/out_study_plans/${reqData.xp_key}`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlansVD());
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};

export const createStudyPlanVD = (reqData) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        await api.post(`/out_study_plans`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlansVD());
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};

export const createCopyStudyPlanVD = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        await api.post(`/out_study_plans/${id}/copy`);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlansVD());
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};

// МО Список предметов
export const getStudyPlanVDCoursesList = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        const { data } = await api.get(`/out_study_plans/${id}/courses`);
        dispatch({ type: SET_STUDY_PLAN_VD_COURSES_LIST, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};

export const addStudyPlanVDCourse = (reqData) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        await api.post(`/out_study_plans/courses`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlanVDCoursesList(reqData.out_tracks));
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};

export const editStudyPlanVDCourse = ({ out_tracks, out_courses, xp_key, cid, name, ...reqData }) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        await api.put(`/out_study_plans/${out_tracks}/courses/${out_courses}`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlanVDCoursesList(out_tracks));
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};

export const deleteStudyPlansCoursesVD = (reqData) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: true });
        await api.delete(`/out_study_plans/courses/${reqData.xp_key}`);
        createNotification('success', 'Успешно');
        await dispatch(getStudyPlanVDCoursesList(reqData.out_tracks));
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        dispatch({ type: SET_STUDY_PLAN_VD_LOADING, payload: false });
    }
};

export const createStudyPlanVDFile = (file, id) => async (dispatch) => {
    try {
        const fd = new FormData();
        fd.append("file", file);
        await api.post(`/out_study_plans/${id}`, fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        createNotification('success', 'Успешно');
        await dispatch(getStudyPlansVDById(id));
    } catch (ERR) {
    }
};

export const getStudyPlanVDFiles = (id) => async (dispatch) => {
    try {
        const { data } = await api.get(`/out_study_plans/${id}/file`);
        dispatch({ type: SET_STUDY_PLAN_VD_FILES, payload: data });
    } catch (ERR) {
        dispatch({ type: SET_STUDY_PLAN_VD_FILES, payload: null });
    }
};
